import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getRooms() {
  
  try {
    const {data} = await axios.get('/api/rooms/get-by-owner');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}



export async function getRoomStudents(id) {
  try {
    const {data} = await axios.post('/api/room/students', {id});
    let payload = [];
    if(data.errcode == 200) {
      payload = data.payload;
      return data.payload;
    } else {
      return []
    }
  } catch (error) {
    return [];
  }
}

export async function getQuizs() {
  
  try {
    const {data} = await axios.get('/api/quizs/get-by-owner');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


export async function updateQuizOrder(body) {
  try {
    const {data} = await axios.post('/api/quizs/order', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function updateRoomsOrder(body) {
  try {
    const {data} = await axios.post('/api/rooms/order', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}
export async function updateQuiz(body) {
  
  try {
    const {data} = await axios.post('/api/quiz/patch', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function updateQuizs(body) {
  
  try {
    const {data} = await axios.post('/api/quiz/balk-update', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function deleteQuiz(body) {
  
  try {
    const {data} = await axios.post('/api/quiz/delete', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function updateRoom(body) {
  
  try {
    const {data} = await axios.post('/api/room/patch', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quizs/actions.js